import React from 'react'
import { ReactComponent as MoveDownIcon } from 'icons/arrow-down-thick.svg'
import { ReactComponent as MoveUpIcon } from 'icons/arrow-up.svg'
import { ReactComponent as MoveToTopIcon } from 'icons/arrow-up-to-line.svg'
import { ReactComponent as MoveToBottomIcon } from 'icons/arrow-down-to-line.svg'

const ElementsToMoveRule = ({ moveCampaign, index }) => {
  const iconSizeProps = { height: 14, width: 14 }
  const moveCampaignFunc = (e, direction) => {
    e.preventDefault()
    moveCampaign[direction](index)
  }
  return (
    <div className="move-operations-container">
      <button
        data-testid="move-top-btn"
        onClick={(e) => moveCampaignFunc(e, 'top')}
      >
        <MoveToTopIcon {...iconSizeProps} />
      </button>
      <button
        data-testid="move-up-btn"
        onClick={(e) => moveCampaignFunc(e, 'up')}
      >
        <MoveUpIcon {...iconSizeProps} />
      </button>
      <button
        data-testid="move-down-btn"
        onClick={(e) => moveCampaignFunc(e, 'down')}
      >
        <MoveDownIcon {...iconSizeProps} />
      </button>
      <button
        data-testid="move-bottom-btn"
        onClick={(e) => moveCampaignFunc(e, 'bottom')}
      >
        <MoveToBottomIcon {...iconSizeProps} />
      </button>
    </div>
  )
}

function CampaignsRanking({
  campaignsOrder,
  moveCampaign,
  toggleLogPopup
}) {
  return (
    <div className='campaigns-ranking'>
      <div className='header'>
        <h4>Campaigns Ranking</h4>
        <button className='view-logs-btn' data-testid='view-logs-btn' onClick={toggleLogPopup}>View Logs</button>
      </div>
      <span className='description'>Move the campaigns to the required position to rank.</span>
      <div className='center-container'>
        {
          campaignsOrder.map((campaign, index) => (
            <div className='single-campaign' key={`${campaign.id}-${campaign.categoryId}`}>
              <span className='campaign-id'>campaign #{campaign.id}</span>
              <div className='campaign-name'>{campaign.name}</div>
              <ElementsToMoveRule moveCampaign={moveCampaign} index={index} />
            </div>
          ))
        }
      </div>
    </div>
  )
}

export default CampaignsRanking;
